import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterCustomer({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    khach_hang: "",
    email: "",
    dien_thoai: "",
    nhom_khach: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.khach_hang) {
      condition.$or.push({
        ma_kh: {
          $regex: filter.khach_hang?.split(" ")?.join(".*"),
          $options: "i",
        },
      });
      condition.$or.push({
        ten_kh: {
          $regex: filter.khach_hang?.split(" ")?.join(".*"),
          $options: "i",
        },
      });
    }
    if (filter.dien_thoai) {
      condition.dien_thoai = { $regex: filter.dien_thoai, $options: "i" };
    }
    if (filter.email) {
      condition.email = { $regex: filter.email, $options: "i" };
    }
    if (filter.nhom_khach) {
      condition.nh_kh = filter.nhom_khach._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Mã, tên khách"
        placeholder="Tìm theo mã, tên khách hàng"
        value={filter.khach_hang}
        onSearch={(val) => setFilter({ ...filter, khach_hang: val })}
      />
      <FilterText
        direction="column"
        label="Email"
        placeholder="Tìm theo email khách hàng"
        value={filter.email}
        onSearch={(val) => setFilter({ ...filter, email: val })}
      />
      <FilterText
        direction="column"
        label="Điện thoại"
        placeholder="Tìm theo điện thoại khách hàng"
        value={filter.dien_thoai}
        onSearch={(val) => setFilter({ ...filter, dien_thoai: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Nhóm khách"
        placeholder="Chọn nhóm khách"
        selectTitle="Chọn nhóm khách"
        placeholderSearch="Tìm theo tên nhóm khách"
        apiCode="dmnhkh"
        searchFields={["group_name"]}
        getOptionLabel={(option) => option.group_name}
        checkEqual={(value, option) => value?._id === option?._id}
        value={filter.nhom_khach}
        onChange={(val) => setFilter({ ...filter, nhom_khach: val })}
      />
    </WrapperFilter>
  );
}

export default FilterCustomer;
